import { Controller } from "@hotwired/stimulus"
import moment from 'moment-timezone';
import { localTZ } from "../lib/date_helpers";

export default class extends Controller {
  static targets = ["select", "local", "utc"]

  static values = {
    selected: String
  }

  connect() {
    this.localTimezoneName = localTZ();
    this.localTimezoneAbbr = moment.tz(this.localTimezoneName).zoneAbbr()

    if(this.selectedValue === this.localTimezoneName) {
      this.localTarget.classList.add("hidden");
    } else {
      this.localTarget.innerHTML = `Local (${this.localTimezoneAbbr})`;
    }

    if(this.selectedTimezoneValue === "Etc/UTC") {
      this.utcTarget.classList.add("hidden");
    }

    this.selectTarget.addEventListener("input", evt => {
      this.setCookieTimezone(evt.target.value)
    })
  }

  setCookieTimezone(zone) {
    document.cookie = `timezone=${zone}; path=/`;
    window.location.reload();
  }

  goLocal() {
    this.setCookieTimezone(this.localTimezoneName)
  }

  goUtc() {
    this.setCookieTimezone("Etc/UTC")
  }
}
